module.exports = __webpack_public_path__ + "img/logo-inline-light.51c24d2c.svg";